import { IProgrammeCard } from '@studyportals/domain-client';

export class SearchStudyCardInfo {
	public constructor(
		public readonly id: string,
		public readonly card: IProgrammeCard,
		public readonly enhanced: boolean
	) {}
}
